import React, { useState } from "react";

interface IProps {
  name: string;
  id: number;
  sms: boolean;
  email: boolean;
  onHandleChange: (type_no: number, email: boolean, sms: boolean) => void;
}

const Notifications: React.FC<IProps> = ({
  id,
  name,
  sms,
  email,
  onHandleChange
}) => {
  return (
    <div className="col-12 col-md-6">
      <div className="res2">
        <div className="form-row">
          <div className="notif mb-0 notification-page__notif">
            <div className="row no-gutters">
              <div className="col-12 col-lg-8 notification-page__name">
                <p className="notif__p">{name}</p>
              </div>
              <div className="col-12 col-lg-3 offset-lg-1 notification-page__checkboxes">
                  <div className="form-row">
                    <div className="form-group col-6 col-lg-12 d-flex justify-content-between px-0 mb-0 pt-1 pt-lg-0">
                      <label htmlFor={`inputemail${id}`} className="w-100 mb-0">
                        <span className="float-left">На e-mail</span>
                        <input
                          type="checkbox"
                          id={`inputemail${id}`}
                          checked={email}
                          onChange={() => onHandleChange(id, !email, sms)}
                        />
                        <span className="checkbox-custom mr-2" />
                      </label>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Notifications;
